import { useMutation } from '@tanstack/react-query';
import { ContactMessage } from '~/shared/types/contact_message';
import { api } from './utils/api-base';

export const useCreateContactMessage = () => {
  return useMutation({
    mutationFn: async (params: {
      user_id?: number;
      name: string;
      subject: string;
      content: string;
      email: string;
    }) => {
      const response = await api.post<ContactMessage>('/contact_messages', params);
      return response.data;
    },
  });
};
